let http = {};
import axios from "axios";
import utils from "./utils";
import config from "../config/config";

// 自定义异常处理方式
function custErrStatusFun(vm, errStatus, errMsg) {
  utils.hideLoading(vm);
  switch (errStatus) {
    case 404:
      utils.error(errMsg || "404");
      break;
    case 403:
      utils.error(errMsg || "登录已过期，请重新登录");
      vm.$store && vm.$store.commit("setToken", "");
      vm.$router.push({
        name: "login",
      });
      break;
    default:
      utils.error(errMsg || "请求失败");
  }
}

// 自定义异常处理方式
function custErrFun(vm, err) {
  console.log(err.status);
  if (err.status == 500 || (err.response && err.response.status == 500)) {
    utils.hideLoading(vm);
    utils.error("请求失败");
  } else if (err.response && err.response.status !== 200) {
    if (err.response.status == 403) {
      utils.error("登录已过期，请重新登录");
      vm.$store && vm.$store.commit("setToken", "");
      vm.$router.push({
        name: "login",
      });
      utils.hideLoading(vm);
    } else {
      if (
        err.response.data.msg ==
        "cn.digital.config.message.CustomMessage.TYPE_HAS_PILE"
      ) {
        utils.error("桩型号已绑定充电桩，无法停用!");
      } else if (
        err.response.data.msg ==
        "cn.digital.config.message.CustomMessage.MATERIALNO_IS_EXISTS.body"
      ) {
        utils.error("成品料号已存在，无法新增!");
      } else if (
        err.response.data.msg ==
        "cn.digital.config.message.CustomMessage.MANUFACTORID_IS_EXISTS.body"
      ) {
        utils.error("厂商编码已存在，无法新增!");
      } else if (
        err.response.data.msg ==
        "cn.digital.config.message.CustomMessage.TYPE_HAS_PILE.body"
      ) {
        utils.error("型号下存在充电桩，无法禁用!");
      } else if (
        err.response.data.msg ==
        "cn.digital.config.message.CustomMessage.VERSIONNO_IS_EXISTS.body"
      ) {
        utils.error("版本号已存在，无法创建!");
      } else {
        utils.error(err.response.data.msg || "请求失败");
      }
      utils.hideLoading(vm);
    }
  } else if (err.message && err.stack) {
    console.log(err);
  } else {
    // TODO 超时处理机制
    // 请求返回的异常
    var errStatus = err.response.status;
    custErrStatusFun(vm, errStatus);
  }
}

// 自定义返回处理
function custResponseFun(vm, res, resolve) {
  // 返回的状态
  const responseStatus = res.data.status;
  const responseMsg = res.data.msg || res.data.messageList;
  switch (responseStatus) {
    case 200:
      resolve(res);
      break;
    default:
      custErrStatusFun(vm, responseStatus, responseMsg);
  }
}

// get 请求
http.get = function(vm, url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params || {},
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          authorization: vm.$store.state.token,
        },
        timeout: config.httpTimeOut,
      })
      .then((res) => {
        custResponseFun(vm, res, resolve);
      })
      .catch((err) => {
        custErrFun(vm, err);
      });
  });
};

// POST 请求
http.post = function(vm, url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, {
        // headers: {
        //   "Content-Type": "application/json;charset=UTF-8",
        //   authorization:
          
        //   "ZD eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ7XCJhY2NvdW50Tm9uRXhwaXJlZFwiOnRydWUsXCJhY2NvdW50Tm9uTG9ja2VkXCI6dHJ1ZSxcImNvcnBOb1wiOlwiQ08xNTI0MTAwNzczODE1XCIsXCJjcmVkZW50aWFsc05vbkV4cGlyZWRcIjp0cnVlLFwiZGF0YUNoZWNrXCI6XCJOXCIsXCJkZWFsTm9cIjpcIlwiLFwiZW5hYmxlZFwiOnRydWUsXCJpc0NvdXBvblwiOmZhbHNlLFwibG9naW5UeXBlXCI6XCIwMVwiLFwicGFzc3dvcmRcIjpcIjMzMGM5NzA3MzI0NjE5MWFjOTY2Njg2NmJmOTkxOTIwXCIsXCJyb2xlSWRcIjpcIkxDRUlRVG81QUZDM0ZGQ1pDR1BTVVZFUERRXCIsXCJzaG93VXNlck5hbWVcIjpcIuadjlwiLFwic3RhdHVzXCI6XCIwMVwiLFwic3RhdHVzTmFtZVwiOlwi5ZCv55SoXCIsXCJ1c2VySWRcIjpcIjVINm9MVUxGVkJDUkxJRE1LWlRaUUJBUFU0XCIsXCJ1c2VyTm9cIjpcIlVTUjE2Njg3MzM0MzA0ODRcIixcInVzZXJQYXNzd29yZFwiOlwiMzMwYzk3MDczMjQ2MTkxYWM5NjY2ODY2YmY5OTE5MjBcIixcInVzZXJQaG9uZVwiOlwiMTM4MDM4MjA3NTFcIixcInVzZXJuYW1lXCI6XCIxMzgwMzgyMDc1MVwiLFwieXVud2VpXCI6XCJcIn0iLCJleHAiOjE3MTAwOTQzODh9.p8Q3_rAGk5PwvMoZqWpQykUI2KoQe-sVJQmSr_5SWTRnkEO0iSUCfac_LSWNdaIxilEh9asGCxNcbQVWm9J4yw"
        // },
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'authorization': vm.$store.state.token
        },
        timeout: config.httpTimeOut
      })
      .then((res) => {
        custResponseFun(vm, res, resolve);
      })
      .catch((err) => {
        custErrFun(vm, err);
      });
  });
};

// DELETE 请求
http.del = function(vm, url) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          authorization: vm.$store.state.token,
        },
        timeout: config.httpTimeOut,
      })
      .then((res) => {
        custResponseFun(vm, res, resolve);
      })
      .catch((err) => {
        custErrFun(vm, err);
      });
  });
};

http.postFormData = function(vm, url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, {
        headers: {
          "Content-Type": "multipart/form-data",
          authorization: vm.$store.state.token,
        },
        timeout: config.httpTimeOut,
      })
      .then((res) => {
        custResponseFun(vm, res, resolve);
      })
      .catch((err) => {
        custErrFun(vm, err);
      });
  });
};

// PUT 请求
http.put = function(vm, url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          authorization: vm.$store.state.token,
        },
        timeout: config.httpTimeOut,
      })
      .then((res) => {
        custResponseFun(vm, res, resolve);
      })
      .catch((err) => {
        custErrFun(vm, err);
      });
  });
};

// ajaxPost
http.pdfPost = function(vm, url, param, suc, err) {
  axios
    .post(url, param, {
      headers: {
        "Content-Type": "application/json",
        authorization: vm.$store.state.token,
      },
      timeout: config.httpTimeOut,
      responseType: "blob",
    })
    .then(function(response) {
      if (response.status === 200 || response.data.status === 200) {
        if (
          response.data.status !== undefined &&
          response.data.status !== 200
        ) {
          utils.error(response.data.messageList[0].messageBody);
          vm.showFix = false;
        } else {
          suc(response);
        }
      } else {
        utils.error(response.data.messageList[0].messageBody);
        vm.showFix = false;
      }
    })
    .catch(function(error) {
      console.log(error);
      if (
        utils.isContains(error.message, "timeout") ||
        error.response.status === 504
      ) {
        utils.error("请求超时");
        vm.showFix = false;
      } else if (error.response.status === 403) {
        // 跳转登录
        utils.logout(vm);
      } else {
        var msg = error.response.data.messageList[0].messageBody;
        if (utils.notNull(msg)) {
          utils.error(msg);
        } else {
          utils.error(msgCfg.sysError);
        }
        vm.showFix = false;
        // util.error('系统异常，请稍后重试！');
      }
    });
};

// PUT 请求
// DELETE 请求
// PATCH 请求
// POST FORM-DATA

export default http;
